/* eslint-disable import/prefer-default-export */
import {
  Sizes,
  SizeResolverService as sizeResolver,
  SizeResolverServiceType,
  SizeNames,
  SizeMaxWidths,
} from "@slhuicore/utils";

declare global {
  interface Window {
    SlhSizeResolver?: SizeResolverServiceType;
    Sizes?: typeof Sizes;
  }
}
(() => {
  window.SlhSizeResolver = sizeResolver;
  window.Sizes = Sizes;
})();

export {
  Sizes,
  sizeResolver,
  SizeResolverServiceType,
  SizeNames,
  SizeMaxWidths,
};
